<template>
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5">
        <circle cx="8" cy="8" r="6.25" />
        <path d="M8 7v4M8 5.5v-.01" stroke-linecap="round" />
    </svg>
</template>

<script lang="ts" setup vapor>
defineOptions({ name: 'InfoIcon' });
</script>
